import * as types from './actionTypes';
import { getRequest, deleteRequest, postRequest } from '../../lib/apiUtils';

export function toggleSidebar(filterType) {
    return dispatch => {
        dispatch({ type: types[`TOGGLE_${filterType}_SIDEBAR_FILTERS`] });
    }
}

export function updateFilters(filterType, update) {
    return dispatch => {
        dispatch({ type: types[`UPDATE_${filterType}_SIDEBAR_FILTERS`], update });
    }
}

export function resetFilters(filterType, applyFilters) {
    return dispatch => {
        dispatch({ type: types[`RESET_${filterType}_SIDEBAR_FILTERS`], applyFilters });
    }
}

export function setAppliedFilters(filterType, filters) {
    return dispatch => {
        dispatch({ type: types[`SET_${filterType}_APPLIED_FILTERS`], filters });
    }
}

export function getSavedSearches(filterType) {
    return async dispatch => {
        dispatch({ type: types[`START_GET_${filterType}_SAVED_SEARCHES`] });

        const response = await getRequest('/savedSearches', { type: filterType }, []);

        dispatch({ type: types[`GET_${filterType}_SAVED_SEARCHES`], response });
    };
}

export function getSavedSearch(filterType, searchId) {
    return async dispatch => {
        dispatch({ type: types[`START_GET_${filterType}_SAVED_SEARCH`] });

        const response = await getRequest(`/savedSearches/${searchId}`);

        dispatch({ type: types[`GET_${filterType}_SAVED_SEARCH`], response });
    }
}

export function createSavedSearch(filterType, title, search) {
    return async dispatch => {
        dispatch({ type: types[`START_CREATE_${filterType}_SAVED_SEARCH`] });

        const response = await postRequest("/savedSearches", { name: title, type: filterType, fields: search });
        response.data = { key: response.data, value: title };
        
        dispatch({ type: types[`CREATE_${filterType}_SAVED_SEARCH`], response });
    };
}

export function deleteSavedSearch(filterType, savedSearchId) {
    return async dispatch => {
        dispatch({ type: types[`START_DELETE_${filterType}_SAVED_SEARCH`], savedSearchId });

        const response = await deleteRequest(`/savedSearches/${savedSearchId}`);
        response.savedSearchId = savedSearchId;

        dispatch({ type: types[`DELETE_${filterType}_SAVED_SEARCH`], response }); 
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/SidebarFilterActions.js